var _defs, _rect, _g, _g2, _g3, _line, _g4, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmployeePortalLpTax(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 105.37 93.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e9aa21;}.cls-2{fill:#fff;}.cls-3{stroke-width:2px;}.cls-3,.cls-4,.cls-5{opacity:.65;}.cls-3,.cls-4,.cls-6{fill:none;stroke:#fff;stroke-miterlimit:10;}.cls-4{stroke-linecap:round;stroke-width:1px;}.cls-6{stroke-width:1.22px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.76,
    y: 3.96,
    width: 85.85,
    height: 85.85,
    rx: 5.1,
    ry: 5.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m90.5,5.52c1.95,0,3.54,1.59,3.54,3.54v75.64c0,1.95-1.59,3.54-3.54,3.54H14.86c-1.95,0-3.54-1.59-3.54-3.54V9.06c0-1.95,1.59-3.54,3.54-3.54h75.64m0-1.56H14.86c-2.82,0-5.1,2.29-5.1,5.1v75.64c0,2.82,2.29,5.1,5.1,5.1h75.64c2.82,0,5.1-2.29,5.1-5.1V9.06c0-2.82-2.29-5.1-5.1-5.1h0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 56.39,
    y: 35.62,
    width: 21.78,
    height: 27.19,
    rx: 0.96,
    ry: 0.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 59.67,
    y: 38.87,
    width: 15.21,
    height: 3.98,
    rx: 0.48,
    ry: 0.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 59.2,
    y: 46.58,
    width: 3.59,
    height: 2.69,
    rx: 0.19,
    ry: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 59.2,
    y: 51.2,
    width: 3.59,
    height: 2.69,
    rx: 0.19,
    ry: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 59.2,
    y: 55.83,
    width: 3.59,
    height: 2.69,
    rx: 0.19,
    ry: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 65.46,
    y: 46.58,
    width: 3.59,
    height: 2.69,
    rx: 0.19,
    ry: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 65.46,
    y: 51.2,
    width: 3.59,
    height: 2.69,
    rx: 0.19,
    ry: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 65.46,
    y: 55.83,
    width: 3.59,
    height: 2.69,
    rx: 0.19,
    ry: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 71.77,
    y: 46.58,
    width: 3.59,
    height: 2.69,
    rx: 0.19,
    ry: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 71.77,
    y: 51.2,
    width: 3.59,
    height: 2.69,
    rx: 0.19,
    ry: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 71.77,
    y: 55.83,
    width: 3.59,
    height: 2.69,
    rx: 0.19,
    ry: 0.19
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m39.79,39.5c.15,0,.29.09.34.23.26.76.9,1.22,1.86,1.22,1.16,0,1.52-.56,1.52-1.16,0-.8-.45-1.17-2.14-1.63-3.76-1.02-4.7-2.44-4.7-4.41,0-2.5,2.09-4.13,5.1-4.13,3.3,0,4.89,1.43,5.23,3.44.04.23-.13.43-.36.43h-2.91c-.17,0-.31-.11-.35-.27-.15-.49-.48-1.05-1.58-1.05-.99,0-1.32.56-1.32,1.09,0,.72.46,1.02,2.4,1.55,3.57.96,4.51,2.4,4.5,4.48-.01,2.86-2.23,4.23-5.46,4.23s-5.14-1.51-5.49-3.6c-.04-.23.13-.43.36-.43h2.99Zm.67-9.41v-1.25c0-.2.16-.37.37-.37h1.99c.2,0,.37.16.37.37v1.25c0,.2-.16.37-.37.37h-1.99c-.2,0-.37-.16-.37-.37Zm.11,14.54v-1.96c0-.2.16-.37.37-.37h2.01c.2,0,.37.16.37.37v1.96c0,.2-.16.37-.37.37h-2.01c-.2,0-.37-.16-.37-.37Z"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 51.74,
    y1: 47.83,
    x2: 32.07,
    y2: 47.83
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m40.88,54.88c0,2.48-.97,3.84-2.78,3.86-1.73,0-2.76-1.15-2.76-3.81,0-2.52,1.09-3.8,2.78-3.8s2.76,1.12,2.76,3.76Zm-3.77.03c0,1.58.31,2.28,1.01,2.28s1.01-.74,1.01-2.3-.28-2.23-1.01-2.23c-.66,0-1.01.62-1.01,2.25Zm.46,9.55l7.07-13.17h1.53l-7.08,13.17h-1.51Zm10.89-3.66c0,2.48-.97,3.84-2.78,3.86-1.72,0-2.76-1.14-2.76-3.81,0-2.51,1.09-3.8,2.78-3.8s2.76,1.12,2.76,3.76Zm-3.77.03c0,1.57.31,2.28,1.01,2.28s1.01-.73,1.01-2.3-.28-2.23-1.01-2.23c-.66,0-1.01.64-1.01,2.25Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m69.5,65.76v7.12c0,1.34-1.09,2.42-2.42,2.42H30.01c-1.34,0-2.42-1.09-2.42-2.42V20.89c0-1.34,1.09-2.42,2.42-2.42h37.07c1.34,0,2.42,1.09,2.42,2.42v12.06"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeePortalLpTax);
export default __webpack_public_path__ + "static/media/EmployeePortal LP Tax.036a852e0864e19384453c24162dbf30.svg";
export { ForwardRef as ReactComponent };